import { PiShareFat } from "react-icons/pi";
import { toast } from "sonner";

interface ShareButtonProps {
  bgColor?: string;
  iconColor?: string;
  shareUrl: string;
  shareTitle: string;
  text: boolean;
  className?: string;
}

const ShareBotton = ({ bgColor, iconColor, shareUrl, shareTitle, text, className }: ShareButtonProps) => {
  // const handleShare = async (e: any) => {
  //   const fullUrl = `${window.location.origin}${shareUrl}`;

  //   e.preventDefault();
  //   e.stopPropagation();

  //   if (navigator.share) {
  //     // Web Share API is supported
  //     try {
  //       await navigator.share({
  //         title: shareTitle,
  //         url: fullUrl,
  //       });
  //     } catch (err) {
  //       console.error("Share cancelled or failed:", err);
  //     }
  //   } else {
  //     // Fallback: Copy to clipboard
  //     try {
  //       await navigator.clipboard.writeText(fullUrl);
  //       alert("Link copied to clipboard!");
  //     } catch (err) {
  //       console.error("Failed to copy:", err);
  //       alert("Failed to copy link.");
  //     }
  //   }
  // };

  const handleShare = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const fullUrl = `${window.location.origin}${shareUrl}`;

    try {
      // Web Share API (must run directly from user interaction)
      if (typeof navigator !== "undefined" && navigator.share && window.isSecureContext) {
        const shareData = {
          title: shareTitle || document.title,
          url: fullUrl,
        };

        // Optional but useful: check if data is shareable (some browsers support this)
        if (navigator.canShare && !navigator.canShare(shareData)) {
          throw new Error("Share data is not supported on this device/browser.");
        }

        await navigator.share(shareData);
        return; // success
      }

      // Fallback: clipboard
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(fullUrl);
        toast.info("Link copied to clipboard!");
        return;
      }

      // Older fallback
      const textArea = document.createElement("textarea");
      textArea.value = fullUrl;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const ok = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (ok) {
        toast.info("Link copied to clipboard!");
      } else {
        toast.error("Copy failed. Please copy manually: " + fullUrl);
      }
    } catch (err: any) {
      // AbortError = user closed/cancelled share sheet (not a real error)
      if (err?.name === "AbortError") {
        return;
      }

      console.error("Share failed:", err);

      // Final fallback try clipboard after share rejection/block
      try {
        await navigator.clipboard.writeText(fullUrl);
        toast.info("Link copied to clipboard!");
      } catch {
        toast.error("Unable to open share sheet. Please copy link manually.");
      }
    }
  };

  return (
    <button className="flex items-center justify-start w-full gap-2" onClick={(e) => handleShare(e)}>
      <div className={`size-8 flex justify-center items-center cursor-pointer ${className} ${bgColor}`}>
        <PiShareFat size={20} color={iconColor ? iconColor : "#D05E2D"} />
      </div>
      {text && <span className="text-textColor">Share</span>}
    </button>
  );
};

export default ShareBotton;
